import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import Loading from '../../Loading';

export default function AddBoard() {

    const [board, setBoard] = useState();
    const [languages, setLanguages] = useState([]);
    const [level, setLevel] = useState();
    const [medium, setMedium] = useState([]);
    const navigate = useNavigate();
    const adminToken = localStorage.getItem("authAdminToken");
    const [loading, setLoading] = useState(true);

    // View Section
    const fetchAllLanguage = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getAllLanguage`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${adminToken}`
            },
        });
        return response.json();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!board) {
            toast.info("Board field is required.");
            return;
        }
        if (!medium) {
            toast.info("Medium field is required.");
            return;
        }

        const board_data = {
            board: board,
            level: level,
            medium: medium,
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/createStudyProfile`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${adminToken}`
                },
                body: JSON.stringify(board_data),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("Study Profile add successfully!");
                setMedium("");
                setBoard("");
                setLevel("");
            } else {
                toast.error("Failed to add study profile. Please try again.");
                navigate('/admin/studyprofile');
            }

        } catch (error) {
            toast.error("An error occurred while adding the study profile. Please try again later.");
        }
    };

    useEffect(() => {
        fetchAllLanguage().then((res) => {
            if (res.status) {
                setLoading(false);
                setLanguages(res?.languages);
            } else {
                toast.error("Failed to load board. Please try again.");
            }
        }).catch((error) => {
            toast.error("Unable to fetch board at the moment.");
        });
    }, []);



    return (
        <>

            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {loading ?
                <Loading />
                :
                <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 42em" }}>
                    <div className="app-ecommerce">
                        <div className="row">
                            <div className="col-12 col-lg-8">
                                <div className="card mb-6">
                                    <div className="card-header">
                                        <h5 className="card-tile mb-0">Add Study Profile</h5>
                                    </div>
                                    <div className="card-body">

                                        <form onSubmit={(event) => { handleSubmit(event) }}>
                                            <div className="row gx-5 mb-5">
                                                <div className="col">
                                                    <div className="form-floating form-floating-outline">
                                                        <input type="text" className="form-control" value={board} onChange={(event) => { setBoard(event.target.value) }} placeholder="Board Name" />
                                                        <label htmlFor="ecommerce-product-sku">Board Name</label>
                                                    </div>
                                                </div>

                                                <div className="mb-5 col ecommerce-select2-dropdown d-flex justify-content-between align-items-center">
                                                    <div className="form-floating form-floating-outline w-100 me-4">
                                                        <select className="form-select form-select-sm" data-placeholder="Select Category" value={level} onChange={(event) => { setLevel(event.target.value) }}>
                                                            <option value="">Select level</option>
                                                            <option value="6-8">6-8</option>
                                                            <option value="9-10">9-10</option>
                                                            <option value="11-12">11-12</option>
                                                        </select>
                                                        <label htmlFor="level">level</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row gx-5 mb-5">
                                                <div className="col">
                                                    <div className="form-floating form-floating-outline">
                                                        <label className="form-label d-block" htmlFor="medium" style={{ marginTop: "-2em" }}>Medium</label>
                                                        <div className="d-flex gap-2">
                                                            {languages.map((langObj) => (
                                                                <div key={langObj.id} className="form-check  mt-3">
                                                                    <input type="checkbox" className="form-check-input" id={langObj.id} checked={medium.includes(langObj.language)}
                                                                        onChange={(event) => {
                                                                            if (event.target.checked) {
                                                                                setMedium([...medium, langObj.language]);
                                                                            } else {
                                                                                setMedium(medium.filter((item) => item !== langObj.language));
                                                                            }
                                                                        }}
                                                                    />
                                                                    <label className="form-check-label fs-6" htmlFor={langObj.id}>
                                                                        {langObj.language}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-2 mx-4">
                                                <button type="submit" className="btn btn-primary">Submit</button>
                                            </div>

                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>
    )
}
